import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useAlert, useStore, useTranslate } from '@/composables/use-globals';
import { useMemberTagsStore } from '@/stores/member-tags';
import { Member } from '@/models/member';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberTagsDialog',
  props: {
  groupId: {
    type: Number,
  },
},
  emits: ['refresh'],
  setup(__props, { expose, emit }) {

const props = __props



expose({ openDialog });

const alert = useAlert();
const store = useStore();
const translate = useTranslate();

const open = ref(false);
const saving = ref(false);
const refresh = ref(false);
const selectedMember = ref<Member | null>(null);
const memberTagsStore = useMemberTagsStore();

const availableTagsForMember = computed(() => {
  if (!selectedMember.value || !selectedMember.value.tags) {
    return memberTagsStore.memberTags;
  }
  return memberTagsStore.memberTags.filter(tag => {
    if (!selectedMember.value || !selectedMember.value.tags || selectedMember.value.tags.length === 0) {
      return true;
    }
    return !selectedMember.value.tags.includes(tag.tag);
  });
});

function openDialog(member: Member) {
  selectedMember.value = member;
  open.value = true;
}

function closeDialog() {
  if (refresh.value) {
    emit('refresh');
    refresh.value = false;
  }
  open.value = false;
  selectedMember.value = null;
}

async function assignMemberTag(member: Member | null, tag: string) {
  if (!member) {
    alert('error', translate('failed_to_update_member_tags') as string);
    return;
  }
  try {
    saving.value = true;
    if (props.groupId) {
      selectedMember.value = await store.dispatch('groupMembers/assignMemberTag', {
        member,
        tag,
        groupId: props.groupId,
      });
    } else {
      await memberTagsStore.assignMemberTag(member?.uuid, tag);
      selectedMember.value = await store.dispatch('members/fetchMember', member?.uuid);
    }
    refresh.value = true;
  } catch {
    alert('error', translate('failed_to_update_member_tags') as string);
  } finally {
    saving.value = false;
  }
}

async function unassignMemberTag(member: Member | null, tag: string) {
  if (!member) {
    alert('error', translate('failed_to_update_member_tags') as string);
    return;
  }
  try {
    saving.value = true;
    if (props.groupId) {
      selectedMember.value = await store.dispatch('groupMembers/unassignMemberTag', {
        member,
        tag,
        groupId: props.groupId,
      });
    } else {
      await memberTagsStore.unassignMemberTag(member?.uuid, tag);
      selectedMember.value = await store.dispatch('members/fetchMember', member?.uuid);
    }
    refresh.value = true;
  } catch {
    alert('error', translate('failed_to_update_member_tags') as string);
  } finally {
    saving.value = false;
  }
}

return { __sfc: true,props, emit, alert, store, translate, open, saving, refresh, selectedMember, memberTagsStore, availableTagsForMember, openDialog, closeDialog, assignMemberTag, unassignMemberTag }
}

})